import {Box} from "@mui/material";
import AuthBanner from "./AuthBanner";
import ChangePasswordForm from "./ChangePasswordForm";

interface Props {}

const ChangePasswordScreen = ({} : Props) => {
    return <Box
        sx={{
            display: 'flex'
        }}
    >
        <AuthBanner/>
        <Box sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            boxShadow: '0 0 10px 0 rgba(0,0,0,0.1)'
        }}>
            <ChangePasswordForm/>
        </Box>
    </Box>
}

export default ChangePasswordScreen